import {AppRoutesPrefixesEnum} from '../../../../../src/components/appRoutesPrefixes';
import {PanelRoute} from '../../../../../src/store/panels/panelRoutes';
import {KnowledgeBaseParameters, KnowledgeBaseParametersTypesEnum} from '../knowledgeBaseParameters';

/*
 * Types.
 */

export type KnowledgeBasePanelRoute = PanelRoute<KnowledgeBaseParameters | undefined>;

/*
 * Routes.
 */

export function buildKnowledgeBasePanelRoutes(): ReadonlyArray<KnowledgeBasePanelRoute> {
  return [
    {
      path: '/article/:articleId',
      getParameters: (_state, {params}) => ({
        type: KnowledgeBaseParametersTypesEnum.ARTICLE,
        location: {
          pathname: buildArticlePathName(params.articleId),
        },
        articleId: params.articleId,
      }),
    },
    {
      path: '/settings',
      getParameters: (_state, {params}) => ({
        type: KnowledgeBaseParametersTypesEnum.SETTINGS,
        location: {
          pathname: buildSettingsPathName(),
        },
      }),
    },
    {
      path: '/list',
      getParameters: (_state, {params}) => ({
        type: KnowledgeBaseParametersTypesEnum.LIST,
        location: {
          pathname: buildListPathName(),
        },
      }),
    },
  ];
}

function buildListPathName() {
  return `${AppRoutesPrefixesEnum.KNOWLEDGE_BASE}/list`;
}

function buildArticlePathName(articleId: number) {
  return `${AppRoutesPrefixesEnum.KNOWLEDGE_BASE}/article/${articleId}`;
}

function buildSettingsPathName() {
  return `${AppRoutesPrefixesEnum.KNOWLEDGE_BASE}/settings`;
}

export function buildListPath() {
  return `/${buildListPathName()}`;
}

export function buildArticlePath(articleId: number) {
  return `/${buildArticlePathName(articleId)}`;
}

export function buildSettingsPath() {
  return `/${buildSettingsPathName()}`;
}
